import { Chip, Typography } from "@mui/material";
import { Project } from "@api/Models";

interface ProjectCardProps {
  project: Project;
}

export function ProjectCard({ project }: ProjectCardProps) {
  return (
    <div className="mb-4">
      <Typography variant="h6" className="font-semibold">
        {project.name}
      </Typography>
      <ul className="list-disc list-inside mb-2">
        {project.responsibilities.map((resp, index) => (
          <li key={index} className="text-sm mb-1">
            {resp}
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap gap-2">
        {project.tech_stack.map((tech, index) => (
          <Chip key={index} label={tech} variant="outlined" size="small" onClick={() => {}} />
        ))}
      </div>
    </div>
  );
}
